/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import store from '../../states/Store';

export default () => 
    <span onClick={() => store.Logs.next([])}>Clear</span>

